import { TextField } from '@mui/material';
import { useEffect } from 'react';
import styled from 'styled-components';
import { border, darkerBackground, darkText, primaryBlue, primaryRed } from '../models/colors';

export const StyledTextField = styled(({ helperText, value, onChange, variant, disabled, autoFocus, ...rest }: any) => {
	let inputElement: HTMLInputElement | null = null;
	useEffect(() => {
		if (inputElement !== null && autoFocus) {
			inputElement.select();
		}
	}, [autoFocus, inputElement]);
	return (
		<TextField
			disabled={disabled || false}
			InputProps={{
				classes: {
					root: 'root',
					input: 'input',
					notchedOutline: 'notchedOutline',
					focused: 'focused',
					error: 'error',
					disabled: 'disabled',
				},
			}}
			InputLabelProps={{
				shrink: true,
				classes: {
					root: 'inputRoot',
					focused: 'inputFocused',
					error: 'inputError',
				},
			}}
			FormHelperTextProps={{
				classes: {
					root: 'helperRoot',
				},
			}}
			value={value}
			onChange={onChange}
			helperText={helperText || ' '}
			variant={variant ? variant : 'outlined'}
			tabIndex={autoFocus ? '0' : '-1'}
			inputRef={(input: HTMLInputElement) => (inputElement = input)}
			fullWidth
			{...rest}
		/>
	);
})`
  margin-bottom: 24px;
  & .root {
    border-radius: 4px;
  }
  & .input {
    color: ${darkText};
    caret-color: ${primaryBlue};
    font-family: 'Roboto', sans-serif;
  }
  & .notchedOutline {
    border-width: 2px;
    border-color: ${p => (p.disabled ? darkerBackground : border)};
  }
  & .focused .notchedOutline {
    border-color: ${primaryBlue};
  }
  & .error .notchedOutline {
    border-color: ${primaryRed};
  }
  & .disabled .notchedOutline {
    border-color: transparent;
  }

  &:not(.focused) {
    color: ${border};
  }
  & .inputRoot {
    padding: 4px;
    color: ${border};
    margin-top: -4px;
    font-family: 'Roboto', sans-serif;
  }
  & .inputFocused {
    color: ${primaryBlue};
  }
  & .inputError {
    color: ${p => (p.disabled ? 'transparent' : primaryRed)};
  }

  & .helperRoot {
    margin-bottom: 8px;
    font-family: 'Roboto', sans-serif;
  }
`;
